import { CompositeDataSetReportInDataSet } from 'libs/end-to-end/src/types/databases/data-sets/composite-data-set-config';
import { Box } from 'apps/sigma2-ui/src/components/ui/Box';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import React from 'react';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const DataSetCompositeReportsFinalReviewComponent = ({
  reports,
}: {
  reports: CompositeDataSetReportInDataSet[];
}) => {
  const language = useLanguage();

  return (
    <Spacing size={'md'} direction={'vertical'}>
      <Box pl={'xs'}>
        <S2Typography
          variant={'headline-5-alt'}
          translatedContent={language.dangerousUserInput({
            value: `Reports`,
          })}
        />
      </Box>

      {reports.map((report, index) => {
        return (
          <Box pl={'md'} key={index}>
            <S2Typography
              variant={'headline-6-alt'}
              translatedContent={language.dangerousUserInput({
                value: `${report.reportName} -> ${report.reportPrefixMatcher}`,
              })}
            />
          </Box>
        );
      })}
    </Spacing>
  );
};
